'use strict';
(() => {
  const hdjf9Story = document.getElementById('hdjf9-story');
  var lt = Object.defineProperty;
  var ct = (i, e, t) =>
    e in i
      ? lt(i, e, { enumerable: !0, configurable: !0, writable: !0, value: t })
      : (i[e] = t);
  var a = (i, e, t) => ct(i, typeof e != 'symbol' ? e + '' : e, t);
  var T = (i, e) => (e != null ? e : document).querySelector(i),
    y = (i, e) => (e != null ? e : document).querySelectorAll(i);
  var ut = (i = 960) => `(min-width: ${i}px)`,
    qe = window.matchMedia(ut());
  var dt = 'is-current',
    ft = (i, e) => {
      i instanceof HTMLButtonElement &&
        i.setAttribute('tabindex', e ? '0' : '-1');
    },
    mt = (i, e) => {
      if (e) {
        i.setAttribute('aria-current', 'true');
        return;
      }
      i.removeAttribute('aria-current');
    },
    H = (i, e, t = {}) => {
      let { rovingTabindex: r = !1, ariaCurrent: o = !1 } = t;
      i.forEach((c, n) => {
        let d = n === e;
        (c.classList.toggle(dt, d), r && ft(c, d), o && mt(c, d));
      });
    };
  var q = {
      ready: 'at-cmn:ready',
      modalOpen: 'at-cmn:modal:open',
      modalClose: 'at-cmn:modal:close',
      accordionTransitionEnd: 'at-cmn:accordion:transition-end',
    },
    V = (i, e, t) => {
      i.dispatchEvent(new CustomEvent(e, { bubbles: !0, detail: t }));
    };
  var O = {
      container: 'data-at-cmn-accordion-container',
      exclusive: 'data-at-cmn-accordion-exclusive',
      details: 'data-at-cmn-accordion-details',
      summary: 'data-at-cmn-accordion-summary',
      content: 'data-at-cmn-accordion-content',
    },
    P = {
      motion: { duration: 300, easing: 'ease-in-out' },
      status: { running: 'running', isOpen: 'is-open' },
      attributes: { animStatus: 'data-anim-status' },
    };
  var U = class U {
    constructor() {
      a(this, 'motion', P.motion);
      a(this, 'setUp', (e) => {
        let t = T(`[${O.summary}]`, e),
          r = T(`[${O.content}]`, e);
        !t ||
          !r ||
          t.addEventListener('click', (o) => {
            (o.preventDefault(),
              e.dataset.animStatus !== P.status.running &&
                this.onSummaryClick(e, r));
          });
      });
      a(this, 'open', (e, t) => {
        (e.setAttribute('open', 'true'),
          e.classList.add(P.status.isOpen),
          this.animate(e, t, U.openingKeyframes(t), !0));
      });
      a(this, 'close', (e, t) => {
        (e.classList.remove(P.status.isOpen),
          this.animate(e, t, U.closingKeyframes(t), !1));
      });
      a(this, 'animate', (e, t, r, o) => {
        t.getAnimations().forEach((n) => n.cancel());
        let c = t.animate(r, this.motion);
        (e.setAttribute(P.attributes.animStatus, P.status.running),
          (c.onfinish = () => {
            (o || e.removeAttribute('open'),
              e.removeAttribute(P.attributes.animStatus),
              V(e, q.accordionTransitionEnd, { isOpen: o, details: e }));
          }));
      });
    }
  };
  (a(U, 'openingKeyframes', (e) => [
    { height: 0, opacity: 0 },
    { height: `${e.offsetHeight}px`, opacity: 1 },
  ]),
    a(U, 'closingKeyframes', (e) => [
      { height: `${e.offsetHeight}px`, opacity: 1 },
      { height: 0, opacity: 0 },
    ]));
  var G = U;
  var J = class extends G {
    constructor() {
      (super(),
        y(`[${O.details}]`).forEach((e) => {
          e.closest(`[${O.exclusive}]`) || this.setUp(e);
        }));
    }
    onSummaryClick(e, t) {
      e.hasAttribute('open') ? this.close(e, t) : this.open(e, t);
    }
  };
  var z = class z extends G {
    constructor() {
      (super(),
        y(`[${O.exclusive}]`).forEach((e) => {
          y(`[${O.details}]`, e).forEach((t) => {
            (this.setUp(t), z.setSummaryActionable(t, !t.hasAttribute('open')));
          });
        }));
    }
    onSummaryClick(e, t) {
      if (e.hasAttribute('open')) return;
      let r = e.closest(`[${O.exclusive}]`),
        o = r ? T(`[${O.details}][open]`, r) : null;
      if (o && o !== e) {
        let c = T(`[${O.content}]`, o);
        (c && this.close(o, c), z.setSummaryActionable(o, !0));
      }
      (this.open(e, t), z.setSummaryActionable(e, !1));
    }
  };
  a(z, 'setSummaryActionable', (e, t) => {
    let r = T(`[${O.summary}]`, e);
    r &&
      (t
        ? (r.removeAttribute('tabindex'), r.removeAttribute('aria-disabled'))
        : (r.setAttribute('tabindex', '-1'),
          r.setAttribute('aria-disabled', 'true')));
  });
  var ee = z;
  var Le = { container: 'data-clone', node: 'data-clone-node' };
  var se = class {
    constructor() {
      a(this, 'containerElms');
      a(this, 'init', () => {
        this.checkElements() && this.setUpClones();
      });
      a(this, 'checkElements', () => this.containerElms.length > 0);
      a(this, 'setUpClones', () => {
        this.containerElms.forEach((e) => {
          let t = y(`[${Le.node}]`, e);
          if (t.length !== 1) return;
          let o = t[0].cloneNode(!0);
          (o.setAttribute('aria-hidden', 'true'), e.appendChild(o));
        });
      });
      ((this.containerElms = y(`[${Le.container}]`)), this.init());
    }
  };
  var le = {
    container: 'data-at-cmn-gallery-container',
    mainImage: 'data-at-cmn-gallery-main-image',
    thumb: 'data-at-cmn-gallery-thumb',
  };
  var ce = class {
    constructor() {
      a(this, 'containerElm');
      a(this, 'mainImageElms');
      a(this, 'thumbElms');
      a(this, 'init', () => {
        this.checkElements() && this.setUpGallery();
      });
      a(
        this,
        'checkElements',
        () =>
          !!(
            this.containerElm &&
            this.mainImageElms.length &&
            this.thumbElms.length
          ),
      );
      a(this, 'setUpGallery', () => {
        this.thumbElms.forEach((e, t) => {
          e.addEventListener('click', () => {
            (H(this.thumbElms, t, { ariaCurrent: !0 }),
              H(this.mainImageElms, t, { rovingTabindex: !0 }));
          });
        });
      });
      ((this.containerElm = T(`[${le.container}]`)),
        (this.mainImageElms = y(`[${le.mainImage}]`, this.containerElm)),
        (this.thumbElms = y(`[${le.thumb}]`, this.containerElm)),
        this.init());
    }
  };
  var ue = {
      target: 'data-menu',
      trigger: 'data-menu-trigger',
      triggerType: 'data-trigger-type',
    },
    M = {
      wrapper: hdjf9Story ? '#hdjf9-story' : 'body',
      triggerType: { open: 'open', close: 'close' },
      status: { isOpen: 'is-menu-open' },
      aria: {
        expanded: 'aria-expanded',
        hidden: 'aria-hidden',
        controls: 'aria-controls',
      },
      escKey: 'Escape',
    };
  var de = class {
    constructor() {
      a(this, 'targetElm');
      a(this, 'triggerElms');
      a(this, 'wrapperElm');
      a(this, 'mql', qe);
      a(this, 'isOpen', !1);
      a(this, 'init', () => {
        this.checkElements() &&
          (this.setControls(),
          this.addEventListeners(),
          this.applyLayout(!this.mql.matches));
      });
      a(
        this,
        'checkElements',
        () => !!(this.targetElm && this.triggerElms.length && this.wrapperElm),
      );
      a(this, 'setControls', () => {
        var t;
        let e = (t = this.targetElm) == null ? void 0 : t.getAttribute('id');
        e &&
          this.triggerElms.forEach((r) => {
            r.setAttribute(M.aria.controls, e);
          });
      });
      a(this, 'addEventListeners', () => {
        (this.triggerElms.forEach((e) => {
          e.addEventListener('click', this.onTriggerClick);
        }),
          window.addEventListener('keydown', this.onKeydown),
          this.mql.addEventListener('change', this.onLayoutChange));
      });
      a(this, 'onTriggerClick', (e) => {
        if (this.mql.matches) return;
        let r = e.currentTarget.getAttribute(ue.triggerType);
        r === M.triggerType.open
          ? this.isOpen || this.open()
          : r === M.triggerType.close
            ? this.isOpen && this.close()
            : this.isOpen
              ? this.close()
              : this.open();
      });
      a(this, 'onKeydown', (e) => {
        e.key !== M.escKey ||
          !this.isOpen ||
          (e.preventDefault(), this.close());
      });
      a(this, 'onLayoutChange', (e) => {
        this.applyLayout(!e.matches);
      });
      a(this, 'applyLayout', (e) => {
        if (!(!this.targetElm || !this.wrapperElm)) {
          if (
            ((this.isOpen = !1),
            this.wrapperElm.classList.remove(M.status.isOpen),
            e)
          ) {
            this.setAria(!1);
            return;
          }
          (this.targetElm.setAttribute(M.aria.hidden, 'false'),
            this.triggerElms.forEach((t) => {
              t.setAttribute(M.aria.expanded, 'false');
            }));
        }
      });
      a(this, 'open', () => {
        !this.targetElm ||
          !this.wrapperElm ||
          this.isOpen ||
          ((this.isOpen = !0),
          this.wrapperElm.classList.add(M.status.isOpen),
          this.setAria(!0));
      });
      a(this, 'close', () => {
        !this.targetElm ||
          !this.wrapperElm ||
          !this.isOpen ||
          ((this.isOpen = !1),
          this.wrapperElm.classList.remove(M.status.isOpen),
          this.setAria(!1));
      });
      a(this, 'setAria', (e) => {
        var t;
        (this.triggerElms.forEach((r) => {
          r.setAttribute(M.aria.expanded, String(e));
        }),
          (t = this.targetElm) == null ||
            t.setAttribute(M.aria.hidden, String(!e)));
      });
      ((this.targetElm = T(`[${ue.target}]`)),
        (this.triggerElms = y(`[${ue.trigger}]`)),
        (this.wrapperElm = T(M.wrapper)),
        this.init());
    }
  };
  var je = [
      'input:not([inert]):not([inert] *)',
      'select:not([inert]):not([inert] *)',
      'textarea:not([inert]):not([inert] *)',
      'a[href]:not([inert]):not([inert] *)',
      'button:not([inert]):not([inert] *)',
      '[tabindex]:not(slot):not([inert]):not([inert] *)',
      'audio[controls]:not([inert]):not([inert] *)',
      'video[controls]:not([inert]):not([inert] *)',
      '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
      'details>summary:first-of-type:not([inert]):not([inert] *)',
      'details:not([inert]):not([inert] *)',
    ],
    fe = je.join(','),
    Be = typeof Element == 'undefined',
    j = Be
      ? function () {}
      : Element.prototype.matches ||
        Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector,
    me =
      !Be && Element.prototype.getRootNode
        ? function (i) {
            var e;
            return i == null || (e = i.getRootNode) === null || e === void 0
              ? void 0
              : e.call(i);
          }
        : function (i) {
            return i == null ? void 0 : i.ownerDocument;
          },
    ve = function (e, t) {
      var r;
      t === void 0 && (t = !0);
      var o =
          e == null || (r = e.getAttribute) === null || r === void 0
            ? void 0
            : r.call(e, 'inert'),
        c = o === '' || o === 'true',
        n =
          c ||
          (t &&
            e &&
            (typeof e.closest == 'function'
              ? e.closest('[inert]')
              : ve(e.parentNode)));
      return n;
    },
    vt = function (e) {
      var t,
        r =
          e == null || (t = e.getAttribute) === null || t === void 0
            ? void 0
            : t.call(e, 'contenteditable');
      return r === '' || r === 'true';
    },
    Ue = function (e, t, r) {
      if (ve(e)) return [];
      var o = Array.prototype.slice.apply(e.querySelectorAll(fe));
      return (t && j.call(e, fe) && o.unshift(e), (o = o.filter(r)), o);
    },
    pe = function (e, t, r) {
      for (var o = [], c = Array.from(e); c.length; ) {
        var n = c.shift();
        if (!ve(n, !1))
          if (n.tagName === 'SLOT') {
            var d = n.assignedElements(),
              h = d.length ? d : n.children,
              C = pe(h, !0, r);
            r.flatten
              ? o.push.apply(o, C)
              : o.push({ scopeParent: n, candidates: C });
          } else {
            var w = j.call(n, fe);
            w && r.filter(n) && (t || !e.includes(n)) && o.push(n);
            var A =
                n.shadowRoot ||
                (typeof r.getShadowRoot == 'function' && r.getShadowRoot(n)),
              K = !ve(A, !1) && (!r.shadowRootFilter || r.shadowRootFilter(n));
            if (A && K) {
              var k = pe(A === !0 ? n.children : A.children, !0, r);
              r.flatten
                ? o.push.apply(o, k)
                : o.push({ scopeParent: n, candidates: k });
            } else c.unshift.apply(c, n.children);
          }
      }
      return o;
    },
    Ge = function (e) {
      return !isNaN(parseInt(e.getAttribute('tabindex'), 10));
    },
    $ = function (e) {
      if (!e) throw new Error('No node provided');
      return e.tabIndex < 0 &&
        (/^(AUDIO|VIDEO|DETAILS)$/.test(e.tagName) || vt(e)) &&
        !Ge(e)
        ? 0
        : e.tabIndex;
    },
    pt = function (e, t) {
      var r = $(e);
      return r < 0 && t && !Ge(e) ? 0 : r;
    },
    ht = function (e, t) {
      return e.tabIndex === t.tabIndex
        ? e.documentOrder - t.documentOrder
        : e.tabIndex - t.tabIndex;
    },
    ze = function (e) {
      return e.tagName === 'INPUT';
    },
    bt = function (e) {
      return ze(e) && e.type === 'hidden';
    },
    gt = function (e) {
      var t =
        e.tagName === 'DETAILS' &&
        Array.prototype.slice.apply(e.children).some(function (r) {
          return r.tagName === 'SUMMARY';
        });
      return t;
    },
    Et = function (e, t) {
      for (var r = 0; r < e.length; r++)
        if (e[r].checked && e[r].form === t) return e[r];
    },
    Tt = function (e) {
      if (!e.name) return !0;
      var t = e.form || me(e),
        r = function (d) {
          return t.querySelectorAll('input[type="radio"][name="' + d + '"]');
        },
        o;
      if (
        typeof window != 'undefined' &&
        typeof window.CSS != 'undefined' &&
        typeof window.CSS.escape == 'function'
      )
        o = r(window.CSS.escape(e.name));
      else
        try {
          o = r(e.name);
        } catch (n) {
          return !1;
        }
      var c = Et(o, e.form);
      return !c || c === e;
    },
    yt = function (e) {
      return ze(e) && e.type === 'radio';
    },
    Ct = function (e) {
      return yt(e) && !Tt(e);
    },
    St = function (e) {
      var t,
        r = e && me(e),
        o = (t = r) === null || t === void 0 ? void 0 : t.host,
        c = !1;
      if (r && r !== e) {
        var n, d, h;
        for (
          c = !!(
            ((n = o) !== null &&
              n !== void 0 &&
              (d = n.ownerDocument) !== null &&
              d !== void 0 &&
              d.contains(o)) ||
            (e != null &&
              (h = e.ownerDocument) !== null &&
              h !== void 0 &&
              h.contains(e))
          );
          !c && o;
        ) {
          var C, w, A;
          ((r = me(o)),
            (o = (C = r) === null || C === void 0 ? void 0 : C.host),
            (c = !!(
              (w = o) !== null &&
              w !== void 0 &&
              (A = w.ownerDocument) !== null &&
              A !== void 0 &&
              A.contains(o)
            )));
        }
      }
      return c;
    },
    Ve = function (e) {
      var t = e.getBoundingClientRect(),
        r = t.width,
        o = t.height;
      return r === 0 && o === 0;
    },
    wt = function (e, t) {
      var r = t.displayCheck,
        o = t.getShadowRoot;
      if (r === 'full-native' && 'checkVisibility' in e) {
        var c = e.checkVisibility({
          checkOpacity: !1,
          opacityProperty: !1,
          contentVisibilityAuto: !0,
          visibilityProperty: !0,
          checkVisibilityCSS: !0,
        });
        return !c;
      }
      if (getComputedStyle(e).visibility === 'hidden') return !0;
      var n = j.call(e, 'details>summary:first-of-type'),
        d = n ? e.parentElement : e;
      if (j.call(d, 'details:not([open]) *')) return !0;
      if (!r || r === 'full' || r === 'full-native' || r === 'legacy-full') {
        if (typeof o == 'function') {
          for (var h = e; e; ) {
            var C = e.parentElement,
              w = me(e);
            if (C && !C.shadowRoot && o(C) === !0) return Ve(e);
            e.assignedSlot
              ? (e = e.assignedSlot)
              : !C && w !== e.ownerDocument
                ? (e = w.host)
                : (e = C);
          }
          e = h;
        }
        if (St(e)) return !e.getClientRects().length;
        if (r !== 'legacy-full') return !0;
      } else if (r === 'non-zero-area') return Ve(e);
      return !1;
    },
    Nt = function (e) {
      if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(e.tagName))
        for (var t = e.parentElement; t; ) {
          if (t.tagName === 'FIELDSET' && t.disabled) {
            for (var r = 0; r < t.children.length; r++) {
              var o = t.children.item(r);
              if (o.tagName === 'LEGEND')
                return j.call(t, 'fieldset[disabled] *') ? !0 : !o.contains(e);
            }
            return !0;
          }
          t = t.parentElement;
        }
      return !1;
    },
    he = function (e, t) {
      return !(t.disabled || bt(t) || wt(t, e) || gt(t) || Nt(t));
    },
    Ae = function (e, t) {
      return !(Ct(t) || $(t) < 0 || !he(e, t));
    },
    Lt = function (e) {
      var t = parseInt(e.getAttribute('tabindex'), 10);
      return !!(isNaN(t) || t >= 0);
    },
    We = function (e) {
      var t = [],
        r = [];
      return (
        e.forEach(function (o, c) {
          var n = !!o.scopeParent,
            d = n ? o.scopeParent : o,
            h = pt(d, n),
            C = n ? We(o.candidates) : d;
          h === 0
            ? n
              ? t.push.apply(t, C)
              : t.push(d)
            : r.push({
                documentOrder: c,
                tabIndex: h,
                item: o,
                isScope: n,
                content: C,
              });
        }),
        r
          .sort(ht)
          .reduce(function (o, c) {
            return (
              c.isScope ? o.push.apply(o, c.content) : o.push(c.content),
              o
            );
          }, [])
          .concat(t)
      );
    },
    Ye = function (e, t) {
      t = t || {};
      var r;
      return (
        t.getShadowRoot
          ? (r = pe([e], t.includeContainer, {
              filter: Ae.bind(null, t),
              flatten: !1,
              getShadowRoot: t.getShadowRoot,
              shadowRootFilter: Lt,
            }))
          : (r = Ue(e, t.includeContainer, Ae.bind(null, t))),
        We(r)
      );
    },
    Qe = function (e, t) {
      t = t || {};
      var r;
      return (
        t.getShadowRoot
          ? (r = pe([e], t.includeContainer, {
              filter: he.bind(null, t),
              flatten: !0,
              getShadowRoot: t.getShadowRoot,
            }))
          : (r = Ue(e, t.includeContainer, he.bind(null, t))),
        r
      );
    },
    B = function (e, t) {
      if (((t = t || {}), !e)) throw new Error('No node provided');
      return j.call(e, fe) === !1 ? !1 : Ae(t, e);
    },
    At = je.concat('iframe:not([inert]):not([inert] *)').join(','),
    be = function (e, t) {
      if (((t = t || {}), !e)) throw new Error('No node provided');
      return j.call(e, At) === !1 ? !1 : he(t, e);
    };
  function Oe(i, e) {
    (e == null || e > i.length) && (e = i.length);
    for (var t = 0, r = Array(e); t < e; t++) r[t] = i[t];
    return r;
  }
  function Ot(i) {
    if (Array.isArray(i)) return Oe(i);
  }
  function Ze(i, e) {
    var t =
      (typeof Symbol != 'undefined' && i[Symbol.iterator]) || i['@@iterator'];
    if (!t) {
      if (Array.isArray(i) || (t = tt(i)) || e) {
        t && (i = t);
        var r = 0,
          o = function () {};
        return {
          s: o,
          n: function () {
            return r >= i.length ? { done: !0 } : { done: !1, value: i[r++] };
          },
          e: function (h) {
            throw h;
          },
          f: o,
        };
      }
      throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    var c,
      n = !0,
      d = !1;
    return {
      s: function () {
        t = t.call(i);
      },
      n: function () {
        var h = t.next();
        return ((n = h.done), h);
      },
      e: function (h) {
        ((d = !0), (c = h));
      },
      f: function () {
        try {
          n || t.return == null || t.return();
        } finally {
          if (d) throw c;
        }
      },
    };
  }
  function Mt(i, e, t) {
    return (
      (e = Ft(e)) in i
        ? Object.defineProperty(i, e, {
            value: t,
            enumerable: !0,
            configurable: !0,
            writable: !0,
          })
        : (i[e] = t),
      i
    );
  }
  function xt(i) {
    if (
      (typeof Symbol != 'undefined' && i[Symbol.iterator] != null) ||
      i['@@iterator'] != null
    )
      return Array.from(i);
  }
  function kt() {
    throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  function Xe(i, e) {
    var t = Object.keys(i);
    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(i);
      (e &&
        (r = r.filter(function (o) {
          return Object.getOwnPropertyDescriptor(i, o).enumerable;
        })),
        t.push.apply(t, r));
    }
    return t;
  }
  function Je(i) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e] != null ? arguments[e] : {};
      e % 2
        ? Xe(Object(t), !0).forEach(function (r) {
            Mt(i, r, t[r]);
          })
        : Object.getOwnPropertyDescriptors
          ? Object.defineProperties(i, Object.getOwnPropertyDescriptors(t))
          : Xe(Object(t)).forEach(function (r) {
              Object.defineProperty(
                i,
                r,
                Object.getOwnPropertyDescriptor(t, r),
              );
            });
    }
    return i;
  }
  function Rt(i) {
    return Ot(i) || xt(i) || tt(i) || kt();
  }
  function It(i, e) {
    if (typeof i != 'object' || !i) return i;
    var t = i[Symbol.toPrimitive];
    if (t !== void 0) {
      var r = t.call(i, e);
      if (typeof r != 'object') return r;
      throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (e === 'string' ? String : Number)(i);
  }
  function Ft(i) {
    var e = It(i, 'string');
    return typeof e == 'symbol' ? e : e + '';
  }
  function tt(i, e) {
    if (i) {
      if (typeof i == 'string') return Oe(i, e);
      var t = {}.toString.call(i).slice(8, -1);
      return (
        t === 'Object' && i.constructor && (t = i.constructor.name),
        t === 'Map' || t === 'Set'
          ? Array.from(i)
          : t === 'Arguments' ||
              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)
            ? Oe(i, e)
            : void 0
      );
    }
  }
  var R = {
      getActiveTrap: function (e) {
        return (e == null ? void 0 : e.length) > 0 ? e[e.length - 1] : null;
      },
      activateTrap: function (e, t) {
        var r = R.getActiveTrap(e);
        t !== r && R.pauseTrap(e);
        var o = e.indexOf(t);
        (o === -1 || e.splice(o, 1), e.push(t));
      },
      deactivateTrap: function (e, t) {
        var r = e.indexOf(t);
        (r !== -1 && e.splice(r, 1), R.unpauseTrap(e));
      },
      pauseTrap: function (e) {
        var t = R.getActiveTrap(e);
        t == null || t._setPausedState(!0);
      },
      unpauseTrap: function (e) {
        var t = R.getActiveTrap(e);
        t && !t._isManuallyPaused() && t._setPausedState(!1);
      },
    },
    _t = function (e) {
      return (
        e.tagName &&
        e.tagName.toLowerCase() === 'input' &&
        typeof e.select == 'function'
      );
    },
    Dt = function (e) {
      return (
        (e == null ? void 0 : e.key) === 'Escape' ||
        (e == null ? void 0 : e.key) === 'Esc' ||
        (e == null ? void 0 : e.keyCode) === 27
      );
    },
    re = function (e) {
      return (
        (e == null ? void 0 : e.key) === 'Tab' ||
        (e == null ? void 0 : e.keyCode) === 9
      );
    },
    Ht = function (e) {
      return re(e) && !e.shiftKey;
    },
    Pt = function (e) {
      return re(e) && e.shiftKey;
    },
    et = function (e) {
      return setTimeout(e, 0);
    },
    te = function (e) {
      for (
        var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), o = 1;
        o < t;
        o++
      )
        r[o - 1] = arguments[o];
      return typeof e == 'function' ? e.apply(void 0, r) : e;
    },
    ge = function (e) {
      return e.target.shadowRoot && typeof e.composedPath == 'function'
        ? e.composedPath()[0]
        : e.target;
    },
    $t = [],
    rt = function (e, t) {
      var r = (t == null ? void 0 : t.document) || document,
        o = (t == null ? void 0 : t.trapStack) || $t,
        c = Je(
          {
            returnFocusOnDeactivate: !0,
            escapeDeactivates: !0,
            delayInitialFocus: !0,
            delayReturnFocus: !0,
            isolateSubtrees: !1,
            isKeyForward: Ht,
            isKeyBackward: Pt,
          },
          t,
        ),
        n = {
          containers: [],
          containerGroups: [],
          tabbableGroups: [],
          adjacentElements: new Set(),
          alreadySilent: new Set(),
          nodeFocusedBeforeActivation: null,
          mostRecentlyFocusedNode: null,
          active: !1,
          paused: !1,
          manuallyPaused: !1,
          delayInitialFocusTimer: void 0,
          recentNavEvent: void 0,
        },
        d,
        h = function (s, l, u) {
          return s && s[l] !== void 0 ? s[l] : c[u || l];
        },
        C = function (s, l) {
          var u =
            typeof (l == null ? void 0 : l.composedPath) == 'function'
              ? l.composedPath()
              : void 0;
          return n.containerGroups.findIndex(function (v) {
            var m = v.container,
              g = v.tabbableNodes;
            return (
              m.contains(s) ||
              (u == null ? void 0 : u.includes(m)) ||
              g.find(function (f) {
                return f === s;
              })
            );
          });
        },
        w = function (s) {
          var l =
              arguments.length > 1 && arguments[1] !== void 0
                ? arguments[1]
                : {},
            u = l.hasFallback,
            v = u === void 0 ? !1 : u,
            m = l.params,
            g = m === void 0 ? [] : m,
            f = c[s];
          if (
            (typeof f == 'function' && (f = f.apply(void 0, Rt(g))),
            f === !0 && (f = void 0),
            !f)
          ) {
            if (f === void 0 || f === !1) return f;
            throw new Error(
              '`'.concat(
                s,
                '` was specified but was not a node, or did not return a node',
              ),
            );
          }
          var b = f;
          if (typeof f == 'string') {
            try {
              b = r.querySelector(f);
            } catch (p) {
              throw new Error(
                '`'
                  .concat(s, '` appears to be an invalid selector; error="')
                  .concat(p.message, '"'),
              );
            }
            if (!b && !v)
              throw new Error(
                '`'.concat(s, '` as selector refers to no known node'),
              );
          }
          return b;
        },
        A = function (s) {
          var l = s.activeElement;
          return l
            ? l.shadowRoot && l.shadowRoot.activeElement !== null
              ? A(l.shadowRoot)
              : l
            : null;
        },
        K = function () {
          var s = w('initialFocus', { hasFallback: !0 });
          if (s === !1) return !1;
          if (s === void 0 || (s && !be(s, c.tabbableOptions))) {
            var l = A(r);
            if (C(l) >= 0) s = l;
            else {
              var u = n.tabbableGroups[0],
                v = u && u.firstTabbableNode;
              s = v || w('fallbackFocus');
            }
          } else s === null && (s = w('fallbackFocus'));
          if (!s)
            throw new Error(
              'Your focus-trap needs to have at least one focusable element',
            );
          return s;
        },
        k = function () {
          if (
            ((n.containerGroups = n.containers.map(function (s) {
              var l = Ye(s, c.tabbableOptions),
                u = Qe(s, c.tabbableOptions),
                v = l.length > 0 ? l[0] : void 0,
                m = l.length > 0 ? l[l.length - 1] : void 0,
                g = u.find(function (p) {
                  return B(p);
                }),
                f = u
                  .slice()
                  .reverse()
                  .find(function (p) {
                    return B(p);
                  }),
                b = !!l.find(function (p) {
                  return $(p) > 0;
                });
              return {
                container: s,
                tabbableNodes: l,
                focusableNodes: u,
                posTabIndexesFound: b,
                firstTabbableNode: v,
                lastTabbableNode: m,
                firstDomTabbableNode: g,
                lastDomTabbableNode: f,
                nextTabbableNode: function (S) {
                  var N =
                      arguments.length > 1 && arguments[1] !== void 0
                        ? arguments[1]
                        : !0,
                    L = l.indexOf(S);
                  return L < 0
                    ? N
                      ? u.slice(u.indexOf(S) + 1).find(function (_) {
                          return B(_);
                        })
                      : u
                          .slice(0, u.indexOf(S))
                          .reverse()
                          .find(function (_) {
                            return B(_);
                          })
                    : l[L + (N ? 1 : -1)];
                },
              };
            })),
            (n.tabbableGroups = n.containerGroups.filter(function (s) {
              return s.tabbableNodes.length > 0;
            })),
            n.tabbableGroups.length <= 0 && !w('fallbackFocus'))
          )
            throw new Error(
              'Your focus-trap must have at least one container with at least one tabbable node in it at all times',
            );
          if (
            n.containerGroups.find(function (s) {
              return s.posTabIndexesFound;
            }) &&
            n.containerGroups.length > 1
          )
            throw new Error(
              "At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.",
            );
        },
        F = function (s) {
          if (s !== !1 && s !== A(document)) {
            if (!s || !s.focus) {
              F(K());
              return;
            }
            (s.focus({ preventScroll: !!c.preventScroll }),
              (n.mostRecentlyFocusedNode = s),
              _t(s) && s.select());
          }
        },
        Ie = function (s) {
          var l = w('setReturnFocus', { params: [s] });
          return l || (l === !1 ? !1 : s);
        },
        Fe = function (s) {
          var l = s.target,
            u = s.event,
            v = s.isBackward,
            m = v === void 0 ? !1 : v;
          ((l = l || ge(u)), k());
          var g = null;
          if (n.tabbableGroups.length > 0) {
            var f = C(l, u),
              b = f >= 0 ? n.containerGroups[f] : void 0;
            if (f < 0)
              m
                ? (g =
                    n.tabbableGroups[n.tabbableGroups.length - 1]
                      .lastTabbableNode)
                : (g = n.tabbableGroups[0].firstTabbableNode);
            else if (m) {
              var p = n.tabbableGroups.findIndex(function (we) {
                var Ne = we.firstTabbableNode;
                return l === Ne;
              });
              if (
                (p < 0 &&
                  (b.container === l ||
                    (be(l, c.tabbableOptions) &&
                      !B(l, c.tabbableOptions) &&
                      !b.nextTabbableNode(l, !1))) &&
                  (p = f),
                p >= 0)
              ) {
                var S = p === 0 ? n.tabbableGroups.length - 1 : p - 1,
                  N = n.tabbableGroups[S];
                g = $(l) >= 0 ? N.lastTabbableNode : N.lastDomTabbableNode;
              } else re(u) || (g = b.nextTabbableNode(l, !1));
            } else {
              var L = n.tabbableGroups.findIndex(function (we) {
                var Ne = we.lastTabbableNode;
                return l === Ne;
              });
              if (
                (L < 0 &&
                  (b.container === l ||
                    (be(l, c.tabbableOptions) &&
                      !B(l, c.tabbableOptions) &&
                      !b.nextTabbableNode(l))) &&
                  (L = f),
                L >= 0)
              ) {
                var _ = L === n.tabbableGroups.length - 1 ? 0 : L + 1,
                  D = n.tabbableGroups[_];
                g = $(l) >= 0 ? D.firstTabbableNode : D.firstDomTabbableNode;
              } else re(u) || (g = b.nextTabbableNode(l));
            }
          } else g = w('fallbackFocus');
          return g;
        },
        oe = function (s) {
          var l = ge(s);
          if (!(C(l, s) >= 0)) {
            if (te(c.clickOutsideDeactivates, s)) {
              d.deactivate({ returnFocus: c.returnFocusOnDeactivate });
              return;
            }
            te(c.allowOutsideClick, s) || s.preventDefault();
          }
        },
        _e = function (s) {
          var l = ge(s),
            u = C(l, s) >= 0;
          if (u || l instanceof Document) u && (n.mostRecentlyFocusedNode = l);
          else {
            s.stopImmediatePropagation();
            var v,
              m = !0;
            if (n.mostRecentlyFocusedNode)
              if ($(n.mostRecentlyFocusedNode) > 0) {
                var g = C(n.mostRecentlyFocusedNode),
                  f = n.containerGroups[g].tabbableNodes;
                if (f.length > 0) {
                  var b = f.findIndex(function (p) {
                    return p === n.mostRecentlyFocusedNode;
                  });
                  b >= 0 &&
                    (c.isKeyForward(n.recentNavEvent)
                      ? b + 1 < f.length && ((v = f[b + 1]), (m = !1))
                      : b - 1 >= 0 && ((v = f[b - 1]), (m = !1)));
                }
              } else
                n.containerGroups.some(function (p) {
                  return p.tabbableNodes.some(function (S) {
                    return $(S) > 0;
                  });
                }) || (m = !1);
            else m = !1;
            (m &&
              (v = Fe({
                target: n.mostRecentlyFocusedNode,
                isBackward: c.isKeyBackward(n.recentNavEvent),
              })),
              F(v || n.mostRecentlyFocusedNode || K()));
          }
          n.recentNavEvent = void 0;
        },
        at = function (s) {
          var l =
            arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
          n.recentNavEvent = s;
          var u = Fe({ event: s, isBackward: l });
          u && (re(s) && s.preventDefault(), F(u));
        },
        De = function (s) {
          (c.isKeyForward(s) || c.isKeyBackward(s)) &&
            at(s, c.isKeyBackward(s));
        },
        He = function (s) {
          Dt(s) &&
            te(c.escapeDeactivates, s) !== !1 &&
            (s.preventDefault(), d.deactivate());
        },
        Pe = function (s) {
          var l = ge(s);
          C(l, s) >= 0 ||
            te(c.clickOutsideDeactivates, s) ||
            te(c.allowOutsideClick, s) ||
            (s.preventDefault(), s.stopImmediatePropagation());
        },
        $e = function () {
          if (n.active) {
            R.activateTrap(o, d);
            var s;
            return (
              c.delayInitialFocus
                ? (s = new Promise(function (l) {
                    n.delayInitialFocusTimer = et(function () {
                      (F(K()), l());
                    });
                  }))
                : F(K()),
              r.addEventListener('focusin', _e, !0),
              r.addEventListener('mousedown', oe, { capture: !0, passive: !1 }),
              r.addEventListener('touchstart', oe, {
                capture: !0,
                passive: !1,
              }),
              r.addEventListener('click', Pe, { capture: !0, passive: !1 }),
              r.addEventListener('keydown', De, { capture: !0, passive: !1 }),
              r.addEventListener('keydown', He),
              s
            );
          }
        },
        ot = function (s) {
          (n.active && !n.paused && d._setSubtreeIsolation(!1),
            n.adjacentElements.clear(),
            n.alreadySilent.clear());
          var l = new Set(),
            u = new Set(),
            v = Ze(s),
            m;
          try {
            for (v.s(); !(m = v.n()).done; ) {
              var g = m.value;
              l.add(g);
              for (
                var f =
                    typeof ShadowRoot != 'undefined' &&
                    g.getRootNode() instanceof ShadowRoot,
                  b = g;
                b;
              ) {
                l.add(b);
                var p = b.parentElement,
                  S = [];
                p
                  ? (S = p.children)
                  : !p &&
                    f &&
                    ((S = b.getRootNode().children),
                    (p = b.getRootNode().host),
                    (f =
                      typeof ShadowRoot != 'undefined' &&
                      p.getRootNode() instanceof ShadowRoot));
                var N = Ze(S),
                  L;
                try {
                  for (N.s(); !(L = N.n()).done; ) {
                    var _ = L.value;
                    u.add(_);
                  }
                } catch (D) {
                  N.e(D);
                } finally {
                  N.f();
                }
                b = p;
              }
            }
          } catch (D) {
            v.e(D);
          } finally {
            v.f();
          }
          (l.forEach(function (D) {
            u.delete(D);
          }),
            (n.adjacentElements = u));
        },
        Ke = function () {
          if (n.active)
            return (
              r.removeEventListener('focusin', _e, !0),
              r.removeEventListener('mousedown', oe, !0),
              r.removeEventListener('touchstart', oe, !0),
              r.removeEventListener('click', Pe, !0),
              r.removeEventListener('keydown', De, !0),
              r.removeEventListener('keydown', He),
              d
            );
        },
        st = function (s) {
          var l = n.mostRecentlyFocusedNode;
          if (l) {
            var u = s.some(function (m) {
              var g = Array.from(m.removedNodes);
              return g.some(function (f) {
                return (
                  f === l || (typeof f.contains == 'function' && f.contains(l))
                );
              });
            });
            if (
              u &&
              n.containers.some(function (m) {
                return m == null ? void 0 : m.isConnected;
              })
            ) {
              k();
              var v = K();
              F(v);
            }
          }
        },
        Se =
          typeof window != 'undefined' && 'MutationObserver' in window
            ? new MutationObserver(st)
            : void 0,
        X = function () {
          Se &&
            (Se.disconnect(),
            n.active &&
              !n.paused &&
              n.containers.map(function (s) {
                Se.observe(s, { subtree: !0, childList: !0 });
              }));
        };
      return (
        (d = {
          get active() {
            return n.active;
          },
          get paused() {
            return n.paused;
          },
          activate: function (s) {
            if (n.active) return this;
            var l = h(s, 'onActivate'),
              u = h(s, 'onPostActivate'),
              v = h(s, 'checkCanFocusTrap'),
              m = R.getActiveTrap(o),
              g = !1;
            if (m && !m.paused) {
              var f;
              ((f = m._setSubtreeIsolation) === null ||
                f === void 0 ||
                f.call(m, !1),
                (g = !0));
            }
            try {
              (v || k(),
                (n.active = !0),
                (n.paused = !1),
                (n.nodeFocusedBeforeActivation = A(r)),
                l == null || l({ trap: d }));
              var b = function () {
                v && k();
                var N = function () {
                    (d._setSubtreeIsolation(!0),
                      X(),
                      u == null || u({ trap: d }));
                  },
                  L = $e();
                L ? L.then(N) : N();
              };
              if (v) return (v(n.containers.concat()).then(b, b), this);
              b();
            } catch (S) {
              if (m === R.getActiveTrap(o) && g) {
                var p;
                (p = m._setSubtreeIsolation) === null ||
                  p === void 0 ||
                  p.call(m, !0);
              }
              throw S;
            }
            return this;
          },
          deactivate: function (s) {
            if (!n.active) return this;
            var l = Je(
              {
                onDeactivate: c.onDeactivate,
                onPostDeactivate: c.onPostDeactivate,
                checkCanReturnFocus: c.checkCanReturnFocus,
              },
              s,
            );
            (clearTimeout(n.delayInitialFocusTimer),
              (n.delayInitialFocusTimer = void 0),
              n.paused || d._setSubtreeIsolation(!1),
              n.alreadySilent.clear(),
              Ke(),
              (n.active = !1),
              (n.paused = !1),
              X(),
              R.deactivateTrap(o, d));
            var u = h(l, 'onDeactivate'),
              v = h(l, 'onPostDeactivate'),
              m = h(l, 'checkCanReturnFocus'),
              g = h(l, 'delayReturnFocus'),
              f = h(l, 'returnFocus', 'returnFocusOnDeactivate');
            u == null || u({ trap: d });
            var b = function () {
                (f && F(Ie(n.nodeFocusedBeforeActivation)),
                  v == null || v({ trap: d }));
              },
              p = function () {
                g && f ? et(b) : b();
              };
            return f && m
              ? (m(Ie(n.nodeFocusedBeforeActivation)).then(p, p), this)
              : (p(), this);
          },
          pause: function (s) {
            return n.active
              ? ((n.manuallyPaused = !0), this._setPausedState(!0, s))
              : this;
          },
          unpause: function (s) {
            return n.active
              ? ((n.manuallyPaused = !1),
                o[o.length - 1] !== this ? this : this._setPausedState(!1, s))
              : this;
          },
          updateContainerElements: function (s) {
            var l = [].concat(s).filter(Boolean);
            return (
              (n.containers = l.map(function (u) {
                return typeof u == 'string' ? r.querySelector(u) : u;
              })),
              c.isolateSubtrees && ot(n.containers),
              n.active && (k(), n.paused || d._setSubtreeIsolation(!0)),
              X(),
              this
            );
          },
        }),
        Object.defineProperties(d, {
          _isManuallyPaused: {
            value: function () {
              return n.manuallyPaused;
            },
          },
          _setPausedState: {
            value: function (s, l) {
              if (n.paused === s) return this;
              if (((n.paused = s), s)) {
                var u = h(l, 'onPause'),
                  v = h(l, 'onPostPause');
                (u == null || u({ trap: d }),
                  Ke(),
                  d._setSubtreeIsolation(!1),
                  X(),
                  v == null || v({ trap: d }));
              } else {
                var m = h(l, 'onUnpause'),
                  g = h(l, 'onPostUnpause');
                m == null || m({ trap: d });
                var f = function () {
                  k();
                  var p = function () {
                      (d._setSubtreeIsolation(!0),
                        X(),
                        g == null || g({ trap: d }));
                    },
                    S = $e();
                  S ? S.then(p) : p();
                };
                f();
              }
              return this;
            },
          },
          _setSubtreeIsolation: {
            value: function (s) {
              c.isolateSubtrees &&
                n.adjacentElements.forEach(function (l) {
                  var u;
                  if (s)
                    switch (c.isolateSubtrees) {
                      case 'aria-hidden':
                        ((l.ariaHidden === 'true' ||
                          ((u = l.getAttribute('aria-hidden')) === null ||
                          u === void 0
                            ? void 0
                            : u.toLowerCase()) === 'true') &&
                          n.alreadySilent.add(l),
                          l.setAttribute('aria-hidden', 'true'));
                        break;
                      default:
                        ((l.inert || l.hasAttribute('inert')) &&
                          n.alreadySilent.add(l),
                          l.setAttribute('inert', !0));
                        break;
                    }
                  else if (!n.alreadySilent.has(l))
                    switch (c.isolateSubtrees) {
                      case 'aria-hidden':
                        l.removeAttribute('aria-hidden');
                        break;
                      default:
                        l.removeAttribute('inert');
                        break;
                    }
                });
            },
          },
        }),
        d.updateContainerElements(e),
        d
      );
    };
  var ie = {
      dialog: 'data-modal',
      modalTrigger: 'data-modal-trigger',
      triggerType: 'data-trigger-type',
    },
    I = {
      triggerType: { open: 'open', close: 'close' },
      status: { isCurrent: 'is-current', isClosing: 'is-closing' },
    },
    x = {
      name: 'specifications',
      selectors: {
        image: 'data-thumbnail-switcher-modal-img',
        prev: 'data-thumbnail-switcher-prev',
        next: 'data-thumbnail-switcher-next',
        syncGalleryMain: 'data-at-cmn-gallery-main-image',
        syncGalleryThumb: 'data-at-cmn-gallery-thumb',
        status: 'data-modal-status',
        trackingPrev: 'data-tracking-prev',
        trackingNext: 'data-tracking-next',
        trackingId: 'data-id',
      },
    };
  var W = class {
    constructor(e) {
      a(this, 'dialogElm');
      a(this, 'openTriggerElms');
      a(this, 'closeTriggerElms');
      a(this, 'onOpen');
      a(this, 'onClose');
      a(this, 'getReturnFocusTarget');
      a(this, 'modalName');
      a(this, 'focusTrap', null);
      a(this, 'open', (e = null) => {
        var r;
        let t = this.dialogElm;
        !t ||
          t.open ||
          ((r = this.onOpen) == null || r.call(this, e),
          t.showModal(),
          this.activateFocusTrap(e),
          V(t, q.modalOpen, { modalName: this.modalName }));
      });
      a(this, 'close', () => {
        let e = this.dialogElm;
        if (!e || !e.open) return;
        if (
          !window
            .getComputedStyle(e)
            .transitionDuration.split(',')
            .some((o) => parseFloat(o) > 0)
        ) {
          e.close();
          return;
        }
        e.classList.add(I.status.isClosing);
        let r = (o) => {
          o.target === e &&
            ((o.propertyName !== 'opacity' && o.propertyName !== 'display') ||
              (e.removeEventListener('transitionend', r),
              e.classList.remove(I.status.isClosing),
              e.close()));
        };
        e.addEventListener('transitionend', r);
      });
      a(this, 'bindCloseTriggers', () => {
        this.closeTriggerElms.forEach((e) => {
          e.addEventListener('click', () => {
            this.close();
          });
        });
      });
      a(this, 'bindDialogLifecycle', () => {
        let e = this.dialogElm;
        e &&
          (e.addEventListener('cancel', (t) => {
            (t.preventDefault(), this.close());
          }),
          e.addEventListener('close', () => {
            var t, r;
            ((t = this.focusTrap) == null || t.deactivate(),
              (this.focusTrap = null),
              (r = this.onClose) == null || r.call(this),
              V(e, q.modalClose, { modalName: this.modalName }));
          }));
      });
      a(this, 'activateFocusTrap', (e) => {
        this.dialogElm &&
          ((this.focusTrap = rt(this.dialogElm, {
            escapeDeactivates: !1,
            initialFocus: !1,
            setReturnFocus: () => {
              var t, r, o;
              return (o =
                (r =
                  (t = this.getReturnFocusTarget) == null
                    ? void 0
                    : t.call(this, e)) != null
                  ? r
                  : e) != null
                ? o
                : !1;
            },
          })),
          this.focusTrap.activate());
      });
      this.modalName = e;
      let t = `[${ie.modalTrigger}="${e}"]`;
      ((this.dialogElm = T(`[${ie.dialog}="${e}"]`)),
        (this.openTriggerElms = y(
          `${t}[${ie.triggerType}="${I.triggerType.open}"]`,
        )),
        (this.closeTriggerElms = y(
          `${t}[${ie.triggerType}="${I.triggerType.close}"]`,
        )),
        this.bindDialogLifecycle());
    }
  };
  var ne = class extends W {
    constructor() {
      var r;
      super(x.name);
      a(this, 'imageElms');
      a(this, 'prevElm');
      a(this, 'nextElm');
      a(this, 'galleryMainElms');
      a(this, 'galleryThumbElms');
      a(this, 'statusElm');
      a(this, 'getReturnFocusTarget', (t) => {
        let r = Array.from(this.galleryMainElms).find((o) =>
          o.classList.contains(I.status.isCurrent),
        );
        return r != null ? r : t;
      });
      a(this, 'init', () => {
        this.checkElements() &&
          (this.bindCloseTriggers(),
          this.bindOpenTriggers(),
          this.bindPrevNext());
      });
      a(
        this,
        'checkElements',
        () =>
          !!(
            this.dialogElm &&
            this.openTriggerElms.length &&
            this.closeTriggerElms.length &&
            this.imageElms.length &&
            this.prevElm &&
            this.nextElm
          ),
      );
      a(this, 'bindOpenTriggers', () => {
        this.openTriggerElms.forEach((t, r) => {
          t.addEventListener('click', () => {
            t.classList.contains(I.status.isCurrent) &&
              (H(this.imageElms, r),
              this.updateControllerTracking(r),
              this.updateStatus(r),
              this.open(t));
          });
        });
      });
      a(this, 'bindPrevNext', () => {
        var t, r;
        ((t = this.prevElm) == null ||
          t.addEventListener('click', () => {
            this.shiftAll(-1);
          }),
          (r = this.nextElm) == null ||
            r.addEventListener('click', () => {
              this.shiftAll(1);
            }));
      });
      a(this, 'shiftAll', (t) => {
        let r = Array.from(this.imageElms).findIndex((n) =>
          n.classList.contains(I.status.isCurrent),
        );
        if (r < 0) return;
        let { length: o } = this.imageElms,
          c = (r + t + o) % o;
        (H(this.imageElms, c),
          H(this.galleryMainElms, c, { rovingTabindex: !0 }),
          H(this.galleryThumbElms, c, { ariaCurrent: !0 }),
          this.updateControllerTracking(c),
          this.updateStatus(c));
      });
      a(this, 'updateControllerTracking', (t) => {
        var n, d;
        let r = this.imageElms[t];
        if (!r) return;
        let o = r.getAttribute(x.selectors.trackingPrev),
          c = r.getAttribute(x.selectors.trackingNext);
        (o &&
          ((n = this.prevElm) == null ||
            n.setAttribute(x.selectors.trackingId, o)),
          c &&
            ((d = this.nextElm) == null ||
              d.setAttribute(x.selectors.trackingId, c)));
      });
      a(this, 'updateStatus', (t) => {
        this.statusElm &&
          (this.statusElm.textContent = `Image ${t + 1} of ${this.imageElms.length}`);
      });
      let t = (r = this.dialogElm) != null ? r : void 0;
      ((this.imageElms = y(`[${x.selectors.image}]`, t)),
        (this.prevElm = T(`[${x.selectors.prev}]`, t)),
        (this.nextElm = T(`[${x.selectors.next}]`, t)),
        (this.galleryMainElms = y(`[${x.selectors.syncGalleryMain}]`)),
        (this.galleryThumbElms = y(`[${x.selectors.syncGalleryThumb}]`)),
        (this.statusElm = T(`[${x.selectors.status}]`, t)),
        this.init());
    }
  };
  var Kt = 'data-movie-frame-container',
    qt =
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share',
    Y = class extends W {
      constructor(t) {
        var r;
        super(t.name);
        a(this, 'frameContainerElm');
        a(this, 'provider');
        a(this, 'onOpen', (t) => {
          let r = this.resolveSrc(t);
          r && this.injectIframe(r);
        });
        a(this, 'onClose', () => {
          if (!this.frameContainerElm) return;
          let t = T('iframe', this.frameContainerElm);
          (t && (t.src = 'about:blank'),
            this.frameContainerElm.replaceChildren());
        });
        a(this, 'init', () => {
          this.checkElements() &&
            (this.bindCloseTriggers(),
            this.bindOpenTriggers(),
            this.bindBackdropClose());
        });
        a(this, 'bindBackdropClose', () => {
          var t;
          (t = this.dialogElm) == null ||
            t.addEventListener('click', (r) => {
              r.target === this.dialogElm && this.close();
            });
        });
        a(
          this,
          'checkElements',
          () =>
            !!(
              this.dialogElm &&
              this.openTriggerElms.length &&
              this.closeTriggerElms.length &&
              this.frameContainerElm
            ),
        );
        a(this, 'bindOpenTriggers', () => {
          this.openTriggerElms.forEach((t) => {
            t.addEventListener('click', () => {
              this.resolveSrc(t) && this.open(t);
            });
          });
        });
        a(this, 'resolveSrc', (t) => {
          var o;
          let r =
            (o =
              t == null ? void 0 : t.getAttribute(this.provider.sourceAttr)) !=
            null
              ? o
              : '';
          return this.provider.buildSrc(r);
        });
        a(this, 'injectIframe', (t) => {
          if (!this.frameContainerElm) return;
          let r = document.createElement('iframe');
          ((r.src = t),
            (r.title = this.provider.iframeTitle),
            (r.allow = qt),
            (r.allowFullscreen = !0),
            this.frameContainerElm.replaceChildren(r));
        });
        ((this.provider = t),
          (this.frameContainerElm = T(
            `[${Kt}]`,
            (r = this.dialogElm) != null ? r : void 0,
          )),
          this.init());
      }
    },
    Vt = (i) => {
      if (!i) return '';
      let e = i.match(/[?&]vid=([a-z0-9]+)/i);
      if (e != null && e[1]) return e[1];
      let t = i.match(/\/([a-z0-9]+)\.html$/i);
      return t != null && t[1] ? t[1] : /^[a-z0-9]+$/i.test(i) ? i : '';
    },
    Me = {
      name: 'youtube',
      sourceAttr: 'data-youtube-id',
      iframeTitle: 'YouTube video player',
      buildSrc: (i) =>
        i
          ? `https://www.youtube-nocookie.com/embed/${encodeURIComponent(i)}?autoplay=1&rel=0`
          : '',
    },
    xe = {
      name: 'tencent',
      sourceAttr: 'data-tencent-video',
      iframeTitle: 'Tencent Video Player',
      buildSrc: (i) => {
        let e = Vt(i);
        return e
          ? `https://v.qq.com/txp/iframe/player.html?vid=${encodeURIComponent(e)}&autoplay=true`
          : '';
      },
    };
  var it = { footer: '#footer' },
    nt = { footerInview: 'is-footer-inview' };
  var Ee = class {
    constructor() {
      let e = T(it.footer);
      if (!e) return;
      new IntersectionObserver(
        (r) => {
          r.forEach((o) => {
            (hdjf9Story || document.body).classList.toggle(nt.footerInview, o.isIntersecting);
          });
        },
        { root: null, threshold: 0 },
      ).observe(e);
    }
  };
  var ae = {
      trigger: 'data-scroll-anchor',
      adjuster: 'data-scroll-anchor-adjuster',
      cancel: 'data-anchor-cancel',
    },
    ke = { keyword: { top: 'top', bottom: 'bottom' } };
  var jt = (i) => {
      window.scrollTo({ top: i, behavior: 'smooth' });
    },
    Q = class Q {
      constructor(e = jt) {
        a(this, 'triggerElms');
        a(this, 'scrollTo');
        a(this, 'setScrollTo', (e) => {
          this.scrollTo = e;
        });
        a(this, 'init', () => {
          this.checkElements() &&
            this.triggerElms.forEach((e) => {
              e.addEventListener('click', this.onClick);
            });
        });
        a(this, 'checkElements', () => this.triggerElms.length > 0);
        a(this, 'onClick', (e) => {
          let t = e.currentTarget,
            r = t.getAttribute(ae.cancel);
          if (r !== null && r !== 'false') return;
          let o = t.getAttribute(ae.trigger) || Q.hashFromHref(t);
          if (!o) return;
          let c = Q.resolveTop(o);
          if (c === null) return;
          e.preventDefault();
          let n = Number(t.getAttribute(ae.adjuster)) || 0;
          this.scrollTo(c + n);
        });
        ((this.triggerElms = y(`[${ae.trigger}]`)),
          (this.scrollTo = e),
          this.init());
      }
    };
  (a(Q, 'hashFromHref', (e) => {
    var r;
    let t = (r = e.getAttribute('href')) != null ? r : '';
    return t.startsWith('#') ? t : '';
  }),
    a(Q, 'resolveTop', (e) => {
      let t = Math.max(
        0,
        document.documentElement.scrollHeight - window.innerHeight,
      );
      if (e === ke.keyword.top) return 0;
      if (e === ke.keyword.bottom) return t;
      let r = null;
      try {
        r = T(e);
      } catch (c) {
        return null;
      }
      if (!r) return null;
      let o = r.getBoundingClientRect().top + window.scrollY;
      return Math.min(Math.max(0, o), t);
    }));
  var Te = Q;
  var Z = { uiColor: 'data-ui-color', uiColorLine: 'data-ui-color-line' };
  var Bt = (i) => {
      let e = i.getAttribute(Z.uiColorLine),
        t = e === null ? 0 : parseFloat(e);
      return Number.isFinite(t) ? Math.min(Math.max(t, 0), 1) : 0;
    },
    ye = class {
      constructor() {
        a(this, 'targets', []);
        a(this, 'current', null);
        a(this, 'ticking', !1);
        a(this, 'measure', () => {
          this.targets.forEach((e) => {
            e.marginTop =
              parseFloat(window.getComputedStyle(e.elm).marginTop) || 0;
          });
        });
        a(this, 'onResize', () => {
          (this.measure(), this.requestApply());
        });
        a(this, 'requestApply', () => {
          this.ticking ||
            ((this.ticking = !0),
            requestAnimationFrame(() => {
              ((this.ticking = !1), this.apply());
            }));
        });
        a(this, 'apply', () => {
          let e = window.innerHeight,
            t = null;
          (this.targets.forEach(
            ({ elm: r, value: o, lineRatio: c, marginTop: n }) => {
              let d = r.getBoundingClientRect(),
                h = e * c;
              d.top - n <= h && d.bottom > h && (t = o);
            },
          ),
            t !== this.current &&
              ((this.current = t),
              t
                ? (hdjf9Story || document.body).setAttribute(Z.uiColor, t)
                : (hdjf9Story || document.body).removeAttribute(Z.uiColor)));
        });
        let e = Array.from(y(`[${Z.uiColor}]`));
        e.length !== 0 &&
          ((this.targets = e.map((t) => {
            var r;
            return {
              elm: t,
              value: (r = t.getAttribute(Z.uiColor)) != null ? r : '',
              lineRatio: Bt(t),
              marginTop: 0,
            };
          })),
          this.measure(),
          window.addEventListener('scroll', this.requestApply, { passive: !0 }),
          window.addEventListener('resize', this.onResize),
          this.apply());
      }
    };
  var Ce = class {
    constructor() {
      a(this, 'clone');
      a(this, 'accordion');
      a(this, 'exclusiveAccordion');
      a(this, 'gallery');
      a(this, 'specificationsModal');
      a(this, 'youtubeModal');
      a(this, 'tencentModal');
      a(this, 'menu');
      a(this, 'scrollAnchor');
      a(this, 'uiColor');
      a(this, 'navFade');
      ((this.clone = new se()),
        (this.accordion = new J()),
        (this.exclusiveAccordion = new ee()),
        (this.gallery = new ce()),
        (this.specificationsModal = new ne()),
        (this.youtubeModal = new Y(Me)),
        (this.tencentModal = new Y(xe)),
        (this.menu = new de()),
        (this.scrollAnchor = new Te()),
        (this.uiColor = new ye()),
        (this.navFade = new Ee()),
        (window.atCmn = this),
        V(document, q.ready, void 0));
    }
  };
  var Re = class {
    constructor() {
      a(this, 'atCmnMain');
      a(this, 'resizeTimeoutId');
      a(this, 'init', () => {
        (window.addEventListener('DOMContentLoaded', this.onContentLoaded, {
          once: !0,
        }),
          window.addEventListener('load', this.onLoaded, { once: !0 }),
          window.addEventListener('resize', this.onResized));
      });
      a(this, 'onContentLoaded', () => {
        this.atCmnMain = new Ce();
      });
      a(this, 'onLoaded', () => {});
      a(this, 'onResized', () => {
        (this.resizeTimeoutId && clearTimeout(this.resizeTimeoutId),
          (this.resizeTimeoutId = window.setTimeout(() => {}, 200)));
      });
      ((this.atCmnMain = null), this.init());
    }
  };
  new Re();
})();
/*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 6.4.0
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 8.2.1
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
*/
